import React, { Component } from "react";
import axios from "axios";
import { Base_url, Image_url, ImagUrlFxn } from "../../requester";
import Swal from "sweetalert2";
import ScrollAnimation from "react-animate-on-scroll";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Footer from "../small components/Footer";
import SignUpform from "../small components/SignUpform";
import Loginform from "../small components/Loginform";
import yellow_Png from "../../assets/images/yellowball.png";
import blue_Png from "../../assets/images/blueball.png";
import Header from "./components/Header";
import Skeleton from "@material-ui/lab/Skeleton";

export default class Profile extends Component {
  state = {
    user: "",
    fullname: "",
    email: "",
    subscription: "",
    subscription_type: "",
    password: "",
    cpassword: "",
    error: "",
    isLoading: false,
    showpassword: false,
    role: "user",
    form: false,
    address: "",
    file: null,
    profile: "",
    profile1: "",
    email_verification: "",
    verifyemailisLoading: false,
  };

  componentDidMount = async () => {
    try {
      this.setState({ isLoading: true });
      const res = await axios.get(`${Base_url}/users/auth`);
      if (res.data.status == "Success") {
        this.setState({
          isLoading: false,
          user: res.data.data,
          subscription_type: res.data.data.subscription_type,
          subscription: res.data.data.subscription,
          email: res.data.data.email,
          fullname: res.data.data.fullname,
          address: res.data.data.address,
          profile: res.data.data.profile,
          email_verification: res.data.data.email_verification,
        });
      }
    } catch (e) {
      this.setState({ isLoading: false });
    }
  };
  edit = () => {
    this.setState({ form: true });
  };

  handleChange = (event) => {
    this.setState({
      file: URL.createObjectURL(event.target.files[0]),
      profile1: event.target.files[0],
    });
  };

  verifyEMailaddress = async () => {
    try {
      this.setState({ verifyemailisLoading: true });
      const res = await axios.post(`${Base_url}/users/sendemail`);
      if (res.data.status == "Success") {
        await Swal.fire("Email Verification", res.data.message, "success");
        this.setState({
          verifyemailisLoading: false,
        });
      }
    } catch (err) {
      await Swal.fire(
        "Email Verification",
        err.response.data.message,
        "warning"
      );
      this.setState({ verifyemailisLoading: false });
    }
  };

  onUpdateProfile = async () => {
    this.setState({
      isLoading: true,
    });
    try {
      var formData = new FormData();
      formData.append("fullname", this.state.fullname);
      formData.append("address", this.state.address);
      formData.append("profile", this.state.profile1);
      const res = await axios.post(Base_url + "/users/updateprofile", formData);
      if (res.data.status == "Success") {
        await Swal.fire("Update Profile", res.data.message, "success");
        this.setState({
          profile: res.data.data.profile,
          isLoading: false,
          form: false,
        });
      }
    } catch (err) {
      await Swal.fire("Update Profile", err.response.data.message, "warning");
      this.setState({
        isLoading: false,
      });
    }
  };
  render() {
    const { isLoading, profile } = this.state;
    if (
      this.props.AuthLoading === false &&
      this.props.isAuthenticated &&
      this.props.user.role == "user"
    ) {
      if (
        this.props.user.subscription_type == "paid" &&
        this.props.user.subscription == false
      ) {
        return <Redirect to="/cardInfo" />;
      }
      return <Redirect to="/watchlist" />;
    }
    return (
      <React.Fragment>
        <div className="container-fluid main-bg">
          <div className="main">
            <Header />
            <ScrollAnimation
              delay={500}
              animateIn="animate__fadeIn"
              animateOnce={true}
            >
              <div className="row mx-auto py-2 mb-lg-5">
                <div className="col-md-9 m-auto py-2">
                  <div className="br-15 bg-white shade hover-shade px-md-5">
                    <img
                      className="position-absolute yellow-ball d-md-block d-none"
                      src={yellow_Png}
                      alt="yellow_ball"
                    />
                    <img
                      className="position-absolute blue-ball d-md-block d-none"
                      src={blue_Png}
                      alt="blue_ball"
                    />
                    <img
                      className="position-absolute small-blue-ball d-md-block d-none"
                      src={blue_Png}
                      alt="smallblue_ball"
                    />
                    <ScrollAnimation
                      delay={500}
                      animateIn="animate__fadeIn"
                      animateOnce={true}
                    >
                      <div className="row">
                        <div className="col-10 col-md-8 m-auto p-4">
                          {this.state.form ? (
                            <form>
                              <div class="form-group">
                                <label className=""> Profile Picture</label>
                                {isLoading ? (
                                  <div className="col-xl-2 px-0">
                                    <Skeleton className="py-5" />
                                  </div>
                                ) : (
                                  <div className="border w-fit rounded p-2 px-3">
                                    <input
                                      type="file"
                                      name="image"
                                      onChange={this.handleChange}
                                      id="e"
                                      className="position-absolute dp"
                                      accept="image/x-png,image/gif,image/jpeg"
                                    />
                                    <span
                                      id="cam-icon-pos"
                                      class="text-black fa fa-camera fa-2x"
                                    ></span>
                                    {this.state.file ? (
                                      <img
                                        width="150"
                                        height="150px"
                                        src={this.state.file}
                                        alt=""
                                      />
                                    ) : (
                                      <img
                                        width="150"
                                        height="150px"
                                        onError={(e) =>
                                          (e.target.src =
                                            "https://media.istockphoto.com/vectors/profile-placeholder-image-gray-silhouette-no-photo-vector-id1016744034?b=1&k=6&m=1016744034&s=612x612&w=0&h=dbicqM9p31ex5Lm-FpsdOjHkPZM_6Lmkb02qJO9SY5E=")
                                        }
                                        src={
                                          profile ? profile : ""
                                          // Image_url +
                                          // ImagUrlFxn(this.state.profile)
                                        }
                                        alt="ssssss"
                                      />
                                    )}
                                  </div>
                                )}
                              </div>
                              <div class="form-group">
                                <label>Edit Full Name</label>

                                <input
                                  type="fullname"
                                  value={this.state.fullname}
                                  onChange={(e) =>
                                    this.setState({ fullname: e.target.value })
                                  }
                                  class="form-control"
                                  placeholder="Enter Full Name"
                                />
                              </div>
                              <div class="form-group">
                                <label>Email </label>
                                <input
                                  type="email"
                                  disabled
                                  value={this.state.email}
                                  class="form-control"
                                  placeholder="email"
                                />
                              </div>

                              <div class="form-group">
                                <label>Address </label>
                                <input
                                  type="text"
                                  value={this.state.address}
                                  class="form-control"
                                  placeholder="Address"
                                  onChange={(e) =>
                                    this.setState({ address: e.target.value })
                                  }
                                />
                              </div>
                              <button
                                type="button"
                                disabled={isLoading}
                                onClick={this.onUpdateProfile}
                                class="btn text-white br-15 px-4 hover-shade py-1 bg-sky zoom-in"
                              >
                                {isLoading && (
                                  <i className="mr-1 fa fa-refresh fa-spin"></i>
                                )}
                                Update
                              </button>
                            </form>
                          ) : (
                            <form>
                              <div class="form-group">
                                <label className=""> Profile Picture</label>
                                {isLoading ? (
                                  <div className="col-xl-2 px-0">
                                    <Skeleton className="py-5" />
                                  </div>
                                ) : (
                                  <div className="border w-fit rounded p-2 px-3">
                                    <img
                                      width="150px"
                                      height="150px"
                                      onError={(e) =>
                                        (e.target.src =
                                          "https://media.istockphoto.com/vectors/profile-placeholder-image-gray-silhouette-no-photo-vector-id1016744034?b=1&k=6&m=1016744034&s=612x612&w=0&h=dbicqM9p31ex5Lm-FpsdOjHkPZM_6Lmkb02qJO9SY5E=")
                                      }
                                      src={
                                        this.state.profile
                                        // Image_url +
                                        // ImagUrlFxn()
                                      }
                                      alt=""
                                    />
                                  </div>
                                )}
                              </div>
                              <div class="form-group">
                                <label> Full Name</label>
                                {isLoading ? (
                                  <div className="w-100 rounded px-0">
                                    <Skeleton className="py-3" />
                                  </div>
                                ) : (
                                  <div className="border w-100 rounded p-2">
                                    {" "}
                                    {this.state.fullname
                                      ? this.state.fullname
                                      : ""}
                                  </div>
                                )}
                              </div>
                              <div class="form-group">
                                <label>Email</label>
                                {isLoading ? (
                                  <div className="w-100 rounded px-0">
                                    <Skeleton className="py-3" />
                                  </div>
                                ) : (
                                  <div className="border w-100 rounded p-2">
                                    {" "}
                                    {this.state.email ? this.state.email : ""}
                                  </div>
                                )}
                              </div>
                              <div class="form-group">
                                <label>Email Verification</label>
                                {isLoading ? (
                                  <div className="w-100 rounded px-0">
                                    <Skeleton className="py-3" />
                                  </div>
                                ) : (
                                  <div class="align-items-center d-flex border w-100 rounded p-1">
                                    {" "}
                                    {this.state.email_verification == true
                                      ? "Email is Verified"
                                      : " Email is not verified"}
                                    {this.state.email_verification == false && (
                                      <button
                                        type="button"
                                        className="ml-auto p-1 btn btn-primary btn-sm float-right"
                                        onClick={() =>
                                          this.verifyEMailaddress()
                                        }
                                      >
                                        {this.state.verifyemailisLoading && (
                                          <i className="mr-1 fa fa-refresh fa-spin"></i>
                                        )}
                                        Verify Email
                                      </button>
                                    )}
                                  </div>
                                  // <div className="border w-100 rounded p-2">
                                  //   {" "}
                                  //   {this.state.email_verification == true
                                  //     ? "Email is Verified"
                                  //     : " Email is not verified"}
                                  //   {this.state.email_verification == false && (
                                  //     <button
                                  //       type="button"
                                  //       onClick={() =>
                                  //         this.verifyEMailaddress()
                                  //       }
                                  //       className="btn bg-sky btn-primary p-1 float-right"
                                  //     >
                                  //       {this.state.verifyemailisLoading && (
                                  //         <i className="mr-1 fa fa-refresh fa-spin"></i>
                                  //       )}
                                  //       Verify Email
                                  //     </button>
                                  //   )}
                                  // </div>
                                )}
                              </div>
                              <div class="form-group">
                                <label>Subscription Status</label>
                                {isLoading ? (
                                  <div className="w-100 rounded px-0">
                                    <Skeleton className="py-3" />
                                  </div>
                                ) : (
                                  <div className="border w-100 rounded p-2">
                                    {this.state.subscription_type == "paid" &&
                                    this.state.subscription
                                      ? "Active"
                                      : "Freemium"}
                                  </div>
                                )}
                              </div>
                              <button
                                type={"button"}
                                disabled={isLoading}
                                class="btn text-white br-15 px-5 hover-shade py-1 bg-sky zoom-in"
                                onClick={this.edit}
                              >
                                {isLoading && (
                                  <i className="mr-1 fa fa-refresh fa-spin"></i>
                                )}
                                Edit
                              </button>
                            </form>
                          )}
                        </div>
                      </div>
                    </ScrollAnimation>
                  </div>
                </div>
              </div>
            </ScrollAnimation>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
  AuthLoading: state.auth.loading,
  auth: state.auth,
});
